import {
    AnvilSelectFieldState,
    PortalStore,
    SelectNewState,
    portalStoreToken,
} from '@servicetitan/cp-ui';
import { inject, injectable } from '@servicetitan/react-ioc';
import { makeObservable, observable, runInAction } from 'mobx';
import { CustomerAddresses, DashboardApi } from '../api';

@injectable()
export class DashboardCustomerAddressesStore {
    @observable customerAddresses: CustomerAddresses[] = [];

    @observable addressesDropdownState = new SelectNewState([]);
    @observable addressesFieldState = new AnvilSelectFieldState<number[]>([]);

    constructor(
        @inject(portalStoreToken) private portalStore: PortalStore,
        @inject(DashboardApi) private dashboardApi: DashboardApi
    ) {
        makeObservable(this);

        this.loadAddresses();
    }

    getSelectedAddress = () => {
        return this.addressesFieldState.value ?? [];
    };

    getCustomerAddress = (customerId: number) => {
        return this.customerAddresses.find(c => c.id === customerId);
    };

    private async loadAddresses() {
        try {
            const customers = await this.dashboardApi.getCustomerAddresses();

            runInAction(() => {
                this.customerAddresses = customers;

                const options = customers.map(customer => ({
                    text: customer.name,
                    options: customer.addresses.map(address => ({
                        value: address.id,
                        text: address.text,
                        data: address.name,
                    })),
                }));

                this.addressesDropdownState = new SelectNewState(options);
            });
        } catch {
            this.portalStore.event('notify', {
                title: 'An error occurred',
                description: 'Please, try again later.',
                status: 'critical',
            });
        }
    }
}
